"use client";

import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";
import { cn } from "@/lib/utils";
function Slider(t0) {
  const $ = _c(26);
  let className;
  let defaultValue;
  let props;
  let t1;
  let t2;
  let value;
  if ($[0] !== t0) {
    ({
      className,
      defaultValue,
      value,
      min: t1,
      max: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = defaultValue;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
    $[6] = value;
  } else {
    className = $[1];
    defaultValue = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
    value = $[6];
  }
  const min = t1 === undefined ? 0 : t1;
  const max = t2 === undefined ? 100 : t2;
  let t3;
  let t4;
  if ($[7] !== defaultValue || $[8] !== max || $[9] !== min || $[10] !== value) {
    t4 = Array.isArray(value) ? value : Array.isArray(defaultValue) ? defaultValue : [min, max];
    $[7] = defaultValue;
    $[8] = max;
    $[9] = min;
    $[10] = value;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  t3 = t4;
  const _values = t3;
  let t5;
  if ($[12] !== className) {
    t5 = cn("relative flex w-full touch-none items-center select-none data-[disabled]:opacity-50 data-[orientation=vertical]:h-full data-[orientation=vertical]:min-h-44 data-[orientation=vertical]:w-auto data-[orientation=vertical]:flex-col", className);
    $[12] = className;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = cn("bg-muted relative grow overflow-hidden rounded-full data-[orientation=horizontal]:h-1.5 data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-1.5");
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <SliderPrimitive.Track data-slot="slider-track" className={t6}><SliderPrimitive.Range data-slot="slider-range" className={cn("bg-primary absolute data-[orientation=horizontal]:h-full data-[orientation=vertical]:w-full")} /></SliderPrimitive.Track>;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== _values.length) {
    t8 = Array.from({
      length: _values.length
    }, _temp);
    $[16] = _values.length;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== defaultValue || $[19] !== max || $[20] !== min || $[21] !== props || $[22] !== t5 || $[23] !== t8 || $[24] !== value) {
    t9 = <SliderPrimitive.Root data-slot="slider" defaultValue={defaultValue} value={value} min={min} max={max} className={t5} {...props}>{t7}{t8}</SliderPrimitive.Root>;
    $[18] = defaultValue;
    $[19] = max;
    $[20] = min;
    $[21] = props;
    $[22] = t5;
    $[23] = t8;
    $[24] = value;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
}
function _temp(_, index) {
  return <SliderPrimitive.Thumb data-slot="slider-thumb" key={index} className="border-primary bg-background ring-ring/50 block size-4 shrink-0 rounded-full border shadow-sm transition-[color,box-shadow] hover:ring-4 focus-visible:ring-4 focus-visible:outline-hidden disabled:pointer-events-none disabled:opacity-50" />;
}
export { Slider };